<div class="sp-mb-48">
  <h4 class="sp-mb-24">More than one panel can be expanded at a time, the first panel is active, the last panel is disabled</h4>
  <ui-collapse>
    <ui-collapse-panel *ngFor="let panel of panels" [collapsePanelHeader]="panel.name" [collapsePanelActive]="panel.active" [collapsePanelDisabled]="panel.disabled">
      <p style="margin: 0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
    </ui-collapse-panel>
  </ui-collapse>
</div>
<div class="sp-mb-48">
  <h4 class="sp-mb-12">Only one panel can be expanded at a time</h4>
  <ui-collapse collapseAccordion>
    <ui-collapse-panel *ngFor="let panel of panels" [collapsePanelHeader]="panel.name" [collapsePanelActive]="panel.active">
      <p>{{ panel.name }} content</p>
    </ui-collapse-panel>
  </ui-collapse>
</div>

<div class="sp-mb-48">
  <h4 class="sp-mb-24">Nested collapses</h4>
  <ui-collapse>
    <ui-collapse-panel *ngFor="let panel of panels" [collapsePanelHeader]="panel.name" [collapsePanelActive]="panel.active">
      <p>{{ panel.name }}</p>
      <div *ngIf="panel.childPanel && panel.childPanel.length > 0">
        <ui-collapse>
          <ui-collapse-panel *ngFor="let childPanel of panel.childPanel" [collapsePanelHeader]="childPanel.name" [collapsePanelActive]="childPanel.active">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          </ui-collapse-panel>
        </ui-collapse>
      </div>
    </ui-collapse-panel>
  </ui-collapse>
</div>

<div class="sp-mb-38">
  <h4 class="sp-mb-24">Custom style collapse</h4>
  <ui-collapse [collapseBordered]="false">
    <ui-collapse-panel
      #p
      *ngFor="let panel of customizedPanels; let isFirst = first"
      [collapsePanelHeader]="panel.name"
      [collapsePanelActive]="panel.active"
      [ngStyle]="panel.customStyle"
      [collapsePanelExpandedIcon]="!isFirst ? panel.icon || expandedIcon : undefined">
      <p>{{ panel.name }} content</p>
      <ng-template #expandedIcon let-active>
        {{ active }}
        <ui-icon uiType="outline:caret-right" class="ant-collapse-arrow" [uiRotate]="p.nzActive ? 90 : -90"></ui-icon>
      </ng-template>
    </ui-collapse-panel>
  </ui-collapse>
</div>
